export default __webpack_public_path__ + "static/media/SBLCentral-AdminLogo-top.63737fe1.png";